import { render, staticRenderFns } from "./integralPage.vue?vue&type=template&id=419a0954&scoped=true&"
import script from "./integralPage.vue?vue&type=script&lang=js&"
export * from "./integralPage.vue?vue&type=script&lang=js&"
import style0 from "./integralPage.vue?vue&type=style&index=0&id=419a0954&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "419a0954",
  null
  
)

export default component.exports